import { render, staticRenderFns } from "./DashboardSalesCustomerRankingTable.vue?vue&type=template&id=cb82efa2"
import script from "./DashboardSalesCustomerRankingTable.vue?vue&type=script&lang=ts"
export * from "./DashboardSalesCustomerRankingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports